import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import logo from "../../assets/logo.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function ForgotPasswordView({ email, setEmail, message, error, handleSubmit }) {
    const { t } = useTranslation();

    return (
        <div className="login-container">
            <LanguageSwitcher variant="auth" />

            <main className="login-box">
                <img
                    src={logo}
                    alt="Ferreira Systeembouw Logo"
                    className="login-logo"
                    loading="eager"
                />

                <h1 className="text-2xl font-bold text-center mb-4">
                    {t('forgotPassword.title')}
                </h1>

                <form onSubmit={handleSubmit} className="login-form" noValidate>
                    <div className="form-group">
                        <label htmlFor="email-input" className="form-label">
                            {t('forgotPassword.emailPlaceholder')}
                        </label>
                        <input
                            type="email"
                            id="email-input"
                            name="email"
                            className="form-input"
                            placeholder={t('forgotPassword.emailPlaceholder')}
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            aria-required="true"
                            aria-invalid={error ? "true" : "false"}
                            autoComplete="email"
                            autoFocus
                        />
                    </div>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-submit w-full"
                            aria-label={t('forgotPassword.sendResetLink')}
                        >
                            {t('forgotPassword.sendResetLink')}
                        </button>
                    </div>
                </form>

                {message && (
                    <div className="success-message mt-4 p-3 rounded-md bg-success text-white" role="status" aria-live="polite">
                        {message}
                    </div>
                )}

                {error && (
                    <div className="error-message mt-4" role="alert" aria-live="polite">
                        {error}
                    </div>
                )}
            </main>
        </div>
    );
}

ForgotPasswordView.propTypes = {
    email: PropTypes.string.isRequired,
    setEmail: PropTypes.func.isRequired,
    message: PropTypes.string,
    error: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
};

export default ForgotPasswordView;
